export default __webpack_public_path__ + "static/media/01.960889d0.jpg";